import React, {useEffect, useState} from 'react'
import {useApi} from "../ApiSession";
import ModalWindow from "../widgets/ModalWindow";
import {DefaultButton} from "../widgets/Buttons";
import Link from "../widgets/Link";

export default ({pipelineType, markdownFile, linkOnly}) => {

    const api = useApi()

    const [htmlH1, setHtmlH1] = useState(null)
    const [htmlParagraph, setHtmlParagraph] = useState(null)
    const [htmlDoc, setHtmlDoc] = useState(null)
    const [popupVisible, setPopupVisible] = useState(false)

    useEffect(() => {
        api.fetchDoc(pipelineType, markdownFile, {format:'for-link'}).then(({h1, p, doc}) => {
            setHtmlH1(h1)
            setHtmlParagraph(p)
            setHtmlDoc(doc)
        })
    },[])


    const  closeModal = () =>setPopupVisible(false)
    const popDoc = () => {

        if(!popupVisible) {
            return null
        }

        return <ModalWindow
            title={htmlH1}
            onClose={closeModal}
            fullScreen={true}
            footer={<DefaultButton caption={"Close"} onClick={closeModal}/>}
        >
            <div className={"prose prose-sm max-w-none drypipe-doc-md"} dangerouslySetInnerHTML={{__html: htmlDoc}}/>
        </ModalWindow>
    }

    if(htmlH1 === null) {
        return <span>...loading</span>
    }
    else if (linkOnly) {
        return <>
            {popDoc()}
            <a
               onClick={() => setPopupVisible(true)}
               className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
               dangerouslySetInnerHTML={{__html: htmlH1}}
            >
            </a>
        </>
    }
    else {
        return <>
            {popDoc()}
            <span
               onClick={() => setPopupVisible(true)}
               className="block p-3 bg-white border border-gray-200 rounded-md shadow-sm hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">

                <h5 className="mb-2 text-xl font-bold tracking-tight text-gray-900 dark:text-white"
                    dangerouslySetInnerHTML={{__html: htmlH1}}
                />
                <div className="font-normal text-gray-700 dark:text-gray-400">
                    <div dangerouslySetInnerHTML={{__html: htmlParagraph}}/>
                    <Link>  ...read more</Link>
                </div>
            </span>
        </>
    }
}